<template>
  <div>
  <v-row>
    <v-col>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="(item, index) of headers">
                <th
                  :key="index.toString()"
                  class="text-left table-tcdc-header"
                >{{ item[`text_${lang}`] }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in membersBenefit" :key="item.id">
              <td v-html="item[`detail_${lang}`] ? item[`detail_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 pl-0 ml-0 mr-12  table-content-tcdc-color "
              ></td>
              <td v-html="item[`rate_${lang}`] ? item[`rate_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color "
                  style="min-width: 175px !important;"
              ></td>
              <td v-html="item[`discount_${lang}`] ? item[`discount_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color "
              ></td>
              <td v-html="item[`service_${lang}`] ? item[`service_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color "
                  style="min-width: 300px !important;"
              ></td>
              <td v-html="item[`meeting_room_${lang}`] ? item[`meeting_room_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color "
              ></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
    <template v-for="(item, index) in members">
      <v-row :key="index" style="margin-bottom: 0 !important;">
        <v-col class="my-12" style="margin-bottom: 0 !important;">
          <div :key="item.title_id" class="vhtml" v-html="item[`title_${lang}`]"></div>
          <div :key="item.description_id" class="vhtml" v-html="item[`content_${lang}`]"></div>
        </v-col>
      </v-row>
    </template>
    <div class="pt-7">
      <GreenButton v-if="!membership['disable_register_button_branch_id'].includes(branchId)" :label="$t('membership.register')" @onPress="joinMember"></GreenButton>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import GreenButton from "../buttons/GreenButton";

export default {
  components: {
    GreenButton
  },
  computed: {
    ...mapState({
      branchId: state => state.Branch.branch_id,
      membership: state => state.ServiceMenu.membership_main,
      membersBenefit: state => {
        return state.ServiceMenu.membership_benefit
      },
      lang: state => state.Branch.lang,
      members: state => {
        return [
          ...state.ServiceMenu.member_tcdc.filter(val => val.member_topic_type_id === 3).map(member => ({
            title_id: member.id,
            description_id : parseInt(member.id) + 20,
            title_th: `<h class="bold sub-header1 text-tcdc-green">` + member.title_th + `</h> <br/><br/>`,
            title_en: `<h class="bold sub-header1 text-tcdc-green">` + member.title_en + `</h> <br/><br/>`,
            content_th: `<span>` + member.detail_th + `</span>`,
            content_en: `<span>` + member.detail_en + `</span>`,
          }))
        ]
      }
    })
  },
  methods:{
    joinMember() {
      window.open('https://my.tcdc.or.th/signup')
    }
  },
  data: () => ({
    headers: [
      {
        text_th: "สมาชิก",
        text_en: "Membership",
        align: "start",
        value: "name"
      },
      { text_th: "ราคา", text_en: "Rate", value: "rate" },
      { text_th: "ส่วนลด", text_en: "Discount", value: "discount" },
      { text_th: "บริการ", text_en: "Service", value: "service" },
      { text_th: "ห้องประชุม", text_en: "Meeting Room", value: "meetingRoom" }
    ],
    bodys: [],
  })
};
</script>

<style lang="scss" scoped>
th,
td {
  min-width: 140px;
}
td {
  padding-top: 20px;
  padding-bottom: 30px;
}

.table-tcdc-header:first-child {
    padding-left: 0px;
  }
.table-tcdc-header {
  font-family: Poppins,Kanit;
  font-size: 16px !important;
  font-weight: 400;
  color: $tcdcGrey1 !important;
}

.table-content-tcdc-color {
  color: $tcdc16;
  font-family: Sarabun;
  font-size: 16px !important;
}
.table-tcdc-vertical-align-top {
  vertical-align: top;
}
</style>
